import React from 'react'
import { Grid, GridRow } from 'semantic-ui-react'

const Home = () => (
          <> 
          <span></span>
          </>
)

export default Home;